// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1oJ26","notes":"Notes_notes__135HL","note":"Notes_note__3pcoW","markdown":"Notes_markdown__uFjOE"};